module.exports = {
  redirectUri: 'https://app.ultraceuticals.in/user/oauth2/redirect',
  apiBaseUrl: 'https://api.ultraceuticals.in',
  authBaseUrl: 'https://api.ultraceuticals.in',
  headers: {
    Authorization: '353650e4-07ff-11ed-861d-0242ac120002',
    'Access-Control-Allow-Origin': '*',
  },
  jsonHeader: {
    'Content-Type': 'application/json',
  },
}
